import { call, put } from "redux-saga/effects";

import { apiRequest } from "../../../Utils/axiosApi";
import { Actions } from "../../constants/actionTypes";

export function* fetchAllPlans(action) {
  try {
    const result = yield call(apiRequest, {
      url: "/plans",
      method: "GET",
    });

    if (result.isApiSuccessful) {
      yield put({ type: Actions.SET_ALL_PLANS, data: result.data });
      action?.meta?.onSuccess(result.data);
    } else {
      yield put({ type: Actions.SET_ALL_PLANS, data: null });
    }
  } catch (err) {
    // Toast("Technical error", "Failed to fetch the Plans", "danger");
    // return { isApiSuccessful: false, data: err };
  }
}

export function* apiGetSpecificPlan(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/plans/specificPlan?orgId=${action.data?.orgId}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      action?.meta?.onSuccess();
      yield put({ type: Actions.SET_GET_SEPCIFIC_PLAN, data: result.data });
    } else {
      action?.meta?.onError();
      yield put({ type: Actions.SET_GET_SEPCIFIC_PLAN, data: null });
    }
  } catch (err) {
    action?.meta?.onError();
    return { isApiSuccessful: false, data: err };
  }
}
export function* apiGetAllLicenses(action) {
  try {
    const result = yield call(apiRequest, {
      url: "/license/all",
      method: "GET",
    });

    if (result.isApiSuccessful) {
      action?.meta?.onSuccess();
      yield put({ type: Actions.SET_ALL_LICENSE, data: result.data });
    } else {
      action?.meta?.onError();
      yield put({ type: Actions.SET_ALL_LICENSE, data: null });
    }
  } catch (err) {
    //Toast("Technical error", "Failed to fetch user plans", "danger");
    return { isApiSuccessful: false, data: err };
  }
}
